import { useParams, Link } from "react-router-dom";
import { Printer } from "lucide-react";
import Seo from "@/components/Seo";
import { byId, STATUS_LABELS } from "@/data/apparitions";
import ApparitionHero from "@/components/apparition/ApparitionHero";
import ApparitionTabs from "@/components/apparition/ApparitionTabs";
import { ScapularGuide, ScapularGuideNavigation } from "@/components/apparition/ScapularGuide";
import SourcesPanel from "@/components/apparition/SourcesPanel";
import NotFoundPage from "./NotFoundPage";
import { RelatedPrayerLinks } from "@/components/apparition/RelatedPrayerLinks";

export default function ApparitionPage() {
  const { id } = useParams();
  const entry = byId(id);
  if (!entry) return <NotFoundPage />;

  return (
    <main data-testid={`apparition-page-${entry.id}`}>
      <Seo
        title={`${entry.title} — ${entry.country}, ${entry.year} · Theotokos · Mater Dei`}
        siteName="Theotokos · Mater Dei"
        type="article"
        image={entry.image.url}
        description={`${entry.overview[0].slice(0, 150)}… Church status: ${entry.labels.map((l) => STATUS_LABELS[l]).join("; ")}.`}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Article",
          headline: entry.title,
          about: `Marian apparition, ${entry.place}, ${entry.dates}`,
          image: entry.image.url,
          author: { "@type": "Organization", name: "Theotokos · Mater Dei" },
        }}
      />
      <ApparitionHero key={entry.id} entry={entry} />
      {entry.id === "mount-carmel" && <ScapularGuideNavigation />}
      <ApparitionTabs key={`tabs-${entry.id}`} entry={entry} />
      {entry.id === "mount-carmel" && <ScapularGuide />}
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-8 lg:px-16"><Link to={`/parish-poster-kit?apparition=${entry.id}&format=full-story`} data-testid="apparition-poster-link" className="inline-flex items-center gap-2 rounded-full border border-marian/25 px-5 py-3 text-sm font-semibold text-marian transition-colors hover:bg-paleblue"><Printer size={17} />Parish printout · {entry.short}</Link></div>
      <SourcesPanel entry={entry} />
      <RelatedPrayerLinks entry={entry} />
    </main>
  );
}
